var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPauseYellowblue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6048_47935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.56126 6H7.59106C7.26518 6 7 6.26639 7 6.59375V14.9062C7 15.2336 7.26518 15.5 7.59106 15.5H9.56128C9.88716 15.5 10.1523 15.2336 10.1523 14.9062V6.59375C10.1523 6.26639 9.88714 6 9.56126 6Z",
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2898 6H12.3196C11.9937 6 11.7285 6.26639 11.7285 6.59375V14.9062C11.7285 15.2336 11.9937 15.5 12.3196 15.5H14.2898C14.6157 15.5 14.8809 15.2336 14.8809 14.9062V6.59375C14.8808 6.26639 14.6156 6 14.2898 6Z",
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 20.9C16.4676 20.9 20.9 16.4677 20.9 11C20.9 5.53239 16.4677 1.09998 11 1.09998C5.53239 1.09998 1.09998 5.53239 1.09998 11C1.09998 16.4676 5.53239 20.9 11 20.9ZM11 22C17.0751 22 22 17.0751 22 11C22 4.92482 17.0751 0 11 0C4.92482 0 0 4.92482 0 11C0 17.0751 4.92482 22 11 22Z",
    fill: "#FFB800"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6048_47935"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseYellowblue);
export default __webpack_public_path__ + "static/media/PauseYellowblue.914e845c434980964d70e61072325726.svg";
export { ForwardRef as ReactComponent };